import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import pendingActions from 'store/pending/actions';
import { connect } from 'react-redux';
import { event } from '@minerva-analytics/pantheon';
import logo2 from '../../assets/logo2.svg';
import logo2Mobile from '../../assets/logo2_mobile.svg';

import ModalWrapper from '../../oldpantheon/components/ModalWrapper';
import SignUpModalIncentive from '../SignUpModalIncentive';
import {
  HeaderContainer,
  HeaderItemContainer,
  LogoContainer,
  LogoLink,
  HeaderLogo,
  HeaderTagline,
  HeaderModalLink,
  HeaderLogoMobile,
  MenuLogoWrapper,
} from './Header.styles';
import Nav from '../../components/Nav';

const PENDING_KEY = `signup`;

export const Header = (props) => {
  const [modal, setModalOpen] = useState(false);

  useEffect(() => {
    if (props.location.hash === `#signup`) {
      setModalOpen(true);
    }
  }, [props.location]);

  const closeModal = () => {
    setModalOpen(false);
    props.destroyPendingData({ id: PENDING_KEY });
  };

  return (
    <HeaderContainer>
      <HeaderItemContainer>
        <MenuLogoWrapper>
          <Nav />
          <LogoLink to="/">
            <HeaderLogoMobile src={ logo2Mobile } alt="Starguide Logo - Free Horoscopes for Life and Love" />
          </LogoLink>
        </MenuLogoWrapper>

        <div>
          <LogoContainer>
            <LogoLink to="/">
              <HeaderLogo src={ logo2 } alt="Starguide Logo - Free Horoscopes for Life and Love" />
            </LogoLink>
          </LogoContainer>
        </div>

        <HeaderTagline>
          <HeaderModalLink
            onClick={() => {
              setModalOpen(true);
              event([`click`, `modal-button-click`, `header`]);
            }}
          >
            Subscribe
          </HeaderModalLink>
        </HeaderTagline>
      </HeaderItemContainer>
      <ModalWrapper
        isOpen={ modal }
        closeModal={() => closeModal()}
        backdropClosesModal
      >
        <SignUpModalIncentive closeModal={() => closeModal()} />
      </ModalWrapper>
    </HeaderContainer>
  );
};

Header.propTypes = {
  location: PropTypes.object,
  destroyPendingData: PropTypes.func.isRequired,
};

export default connect(() => ({
}), {
  destroyPendingData: pendingActions.destroyPendingData,
})(withRouter(Header));
